export default {
  accounts: []
};
